import { FC, useMemo, useState } from "react";
import { NamedRow } from "../../../../../components/GeneralUI/NamedRow/NamedRow";
import { SlideOverWrapper } from "../SlideOverWrapper/SlideOverWrapper";
import { Restricted } from "../../../../../components/Restricted";
import { PureVoidFunc } from "../../../../../helpers/functions/types";
import { capitalizeAssociatedPress } from "../../../../../helpers/string/capitalize";
import { ButtonType } from "../../../molecules/types";

export const AcceptableNamedRow: FC<
  React.PropsWithChildren<{
    title: string;
    permissionsGroup: string;
    initConfig?: PureVoidFunc;
    allowSubmit?: boolean;
    onSubmit?: () => Promise<boolean>;
    content?: any;
    message?: string;
    buttonType?: ButtonType;
    buttonTitle?: string;
  }>
> = ({
  title,
  permissionsGroup,
  initConfig,
  allowSubmit,
  onSubmit,
  children,
  content,
  message,
  buttonType,
  buttonTitle,
}) => {
  const [open, setOpen] = useState(false);

  const slideOverTitle = useMemo(
    () => `${title}${typeof content === "number" ? ` (${content})` : ""}`,
    [title, content],
  );

  return (
    <Restricted permissions={`${permissionsGroup}:view`}>
      <NamedRow
        title={capitalizeAssociatedPress(title)}
        onClick={() => setOpen(true)}
        editPermissions={`${permissionsGroup}:update`}
        content={content}
        isButton={content === undefined}
      />
      <SlideOverWrapper
        open={open}
        onClose={() => setOpen(false)}
        title={slideOverTitle}
        initConfig={initConfig}
        buttonProps={
          onSubmit
            ? {
                disabled: !allowSubmit,
                onClick: onSubmit,
                buttonType,
                title: buttonTitle,
              }
            : undefined
        }
        message={message}
      >
        {children}
      </SlideOverWrapper>
    </Restricted>
  );
};
